import { Component, ElementRef, Renderer2, AfterViewInit, input, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CreatureLiteWebDto } from '../../../../../../dtos/creature.lite.web.dto';
import { CommonModule } from '@angular/common';
import { RarityType } from '../../../../../../enums/rarity.type';
import { RarityNamePipe } from '../../../../../../pipes/rarity-name.pipe';
import { CreatureTypePipe } from '../../../../../../pipes/creature-type.pipe';
import { EthPricePipe } from '../../../../../../pipes/eth-price.pipe';
import { TimeAgoPipe } from '../../../../../../pipes/time-ago.pipe';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'item-creature-component',
  templateUrl: './item-creature.component.html',
  styleUrls: ['./item-creature.component.scss'],
  imports: [
    CommonModule,
    RarityNamePipe,
    CreatureTypePipe,
    EthPricePipe,
    TimeAgoPipe,
    TranslateModule
  ]
})
export class ItemCreatureComponent {
  @Input()
  public creature!: CreatureLiteWebDto;

  public rarityType: typeof RarityType = RarityType;
}